export default {"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};